import React, { useEffect } from 'react';
import {
  Modal,
  Form,
  Input,
  Button,
  Typography,
  Space,
} from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react-lite';
import objectStore from '../../store/ObjectStore';

const { Title } = Typography;

const ObjectModalForm = observer(({ open, onClose, object = null }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      if (object) {
        form.setFieldsValue({
          name: object.name || '',
          bitrixFolderLink: object.bitrixFolderLink || '',
        });
      } else {
        form.setFieldsValue({
          name: '',
          bitrixFolderLink: '',
        });
      }
    } else {
      form.resetFields();
    }
  }, [open, object, form]);

  const handleFinish = async (values) => {
    const payload = {
      name: values.name,
      bitrixFolderLink: values.bitrixFolderLink,
      equipmentCount: 0,
      nextCheckInDays: 0,
    };

    try {
      if (object?.id) {
        objectStore.updateObject(object.id, payload);
      } else {
        objectStore.addObject(payload);
      }
      onClose();
    } catch (err) {
      console.error('Ошибка при сохранении объекта:', err);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={() => form.submit()}
      title={object ? 'Редактировать объект' : 'Добавить объект'}
      okText="Сохранить"
      cancelText="Отмена"
      destroyOnClose
    >
      <Form layout="vertical" form={form} onFinish={handleFinish} autoComplete="off">
        <Form.Item
          label="Название"
          name="name"
          rules={[{ required: true, message: 'Введите название объекта' }]}
        >
          <Input maxLength='100' showCount placeholder="Например, Московская областная больница" />
        </Form.Item>

        <Form.Item
          label="Ссылка на папку в Битрикс"
          name="bitrixFolderLink"
          rules={[{ message: 'Введите ссылку на папку в Битрикс' }]}
        >
          <Input placeholder="https://bitrix24.example.com/folder" />
        </Form.Item>
      </Form>
    </Modal>
  );
});

export default ObjectModalForm;
